let moment = require('moment');

export const YEARS = () => {
  const years = [];
  const dateStart = moment();
  const dateEnd = moment().add(1, 'y');
  while (dateEnd.diff(dateStart, 'years') >= 0) {
    years.push(dateStart.format('YYYY'));
    dateStart.add(1, 'year');
  }
  return years;
};

export const MONTHS = () => {
  const months = [];
  for (let i = 0; i < 12; i++) {
    months.push(i);
  }

  return months;
};

export const DAYS = (selectedMonth, selectedYear) => {
  let defaultYear = moment().year();
  let defaultMonth = 0;

  let month = !selectedMonth ? defaultMonth : selectedMonth;
  let year = !selectedYear ? defaultYear : selectedYear;

  let daysInMonth = moment(
    `${year}-${parseInt(month) + 1}`,
    'YYYY-MM'
  ).daysInMonth();

  const days = [];
  for (let i = 0; i < daysInMonth; i++) {
    days.push(i + 1);
  }

  return days;
};

export function nameMonth(monthValue) {
  switch (monthValue) {
    case 0:
      return 'Tammikuu';
    case 1:
      return 'Helmikuu';
    case 2:
      return 'Maaliskuu';
    case 3:
      return 'Huhtikuu';
    case 4:
      return 'Toukokuu';
    case 5:
      return 'Kesäkuu';
    case 6:
      return 'Heinäkuu';
    case 7:
      return 'Elokuu';
    case 8:
      return 'Syyskuu';
    case 9:
      return 'Lokakuu';
    case 10:
      return 'Marraskuu';
    case 11:
      return 'Joulukuu';
    default:
      return '';
  }
}
